export default __webpack_public_path__ + "static/media/wemble_black.2c381eca.png";